import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getAiChatResponse = {
  name: "getAiChatResponse" as const,
  input: z.object({
    newChats: MessageSchema.array(),
    returnId: zExt.objectId(),
  }),
  output: z.object({
    chatHistory: MessageSchema.array(),
    threadId: z.string(),
  }),
};
